import React from 'react';
import styles from './half-hero.module.scss';


class HalfHero extends React.Component {

  render () {
    return (
      <div className={styles.halfHero}>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            {this.props.children}
          </div>
        </div>
        <div className={styles.image} style={{backgroundImage: `url(${this.props.image})`}}></div>
      </div>
    )
  }
}

export default HalfHero;


// WEBPACK FOOTER //
// ./src/components/HalfHero/index.js